<template>
  <div>
    <div class="container">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" href="#"  @click.prevent="activeTab='policycaseFormConfiguration'"
             :class="{'active': activeTab === 'policycaseFormConfiguration'}">{{ 'POLICYCASE_FORM_CONFIGURATION' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click.prevent="activeTab='customerFormConfiguration'"
             :class="{'active': activeTab === 'customerFormConfiguration'}">{{ 'CUSTOMER_FORM_CONFIGURATION' | translate }}</a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <policycase-form-configuration-management v-if="activeTab === 'policycaseFormConfiguration'"></policycase-form-configuration-management>
      <customer-configuration-management v-if="activeTab === 'customerFormConfiguration'"></customer-configuration-management>
    </div>
  </div>
</template>

<script>
    import CustomerConfigurationManagement from './CustomerConfigurationManagement';
    import PolicycaseFormConfigurationManagement from './PolicycaseFormConfigurationManagement';

    export default {
      components: {
        CustomerConfigurationManagement,
        PolicycaseFormConfigurationManagement
      },
      data: function() {
        return {
          activeTab: 'customerFormConfiguration'
        }
      }
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/admin/ConfigurationManagement.vue